import LazyLoad from "vanilla-lazyload";

export function setupLazyLoad() {
  var lazyLoadInstance = new LazyLoad({
    // Your custom settings go here
  });
}
